(function(){
  let PIN_DATA = {};
  let PRODUCT_CATALOG = [];
  const form = document.getElementById('serviceForm');
  const successMsg = document.getElementById('successMsg');
  const errorMsg = document.getElementById('errorMsg');
  const submitBtn = document.getElementById('submitBtn');
  const TODAY_STR = new Date().toISOString().slice(0, 10);

  // Product catalog Excel loads asynchronously — gate model search until ready
  // so customers don't briefly see an empty list / "Can't find your product".
  const earlyConfig = window.FanServiceFormConfig || {};
  let catalogLoadState = earlyConfig.productCatalogFileUrl ? 'loading' : 'ready';

  // Built from the Excel file URL into:
  // [MODEL_CODE, MODEL_DESCRIPTION, PRODUCT_GROUP, BRAND, PRODUCT]
  // e.g. ["915006704503","EcoLink AiroTrio 1200mm P BLK","Fans","EcoLink","BLDCCeiling"]
  const CATALOG_BY_ITEMCODE = {};
  function rebuildCatalogIndex(){
    Object.keys(CATALOG_BY_ITEMCODE).forEach(function(key){ delete CATALOG_BY_ITEMCODE[key]; });
    PRODUCT_CATALOG.forEach(function(entry){ CATALOG_BY_ITEMCODE[entry[0]] = entry; });
  }
  rebuildCatalogIndex();

  function refreshAllCatalogUI(){
    if (!productBlocksContainer) return;
    productBlocksContainer.querySelectorAll('.product-block').forEach(function(block){
      if (typeof block._refreshCatalogUI === 'function') block._refreshCatalogUI();
    });
  }

  let currentIsRepair = true;

  const repairSection = document.getElementById('repairSection');
  const addressLabel = document.getElementById('addressLabel');
  const labelRepair = document.getElementById('labelRepair');
  const labelInstall = document.getElementById('labelInstall');

  const issueCategory = document.getElementById('issueCategory');
  const issueDescription = document.getElementById('issueDescription');

  const productBlocksContainer = document.getElementById('productBlocksContainer');
  const addProductBtn = document.getElementById('addProductBtn');
  let blockCounter = 1; // block 0 already exists in the markup

  function filterFanTypesByBrand(block){
    const brandSelect = block.querySelector('.brand-select');
    const fanTypeSelect = block.querySelector('.fanType-select');
    const fanTypeHint = block.querySelector('.fanType-hint');
    const brand = brandSelect.value;
    let currentStillValid = false;

    Array.from(fanTypeSelect.options).forEach(function(opt){
      if (!opt.value) return; // keep placeholder always visible
      const brands = (opt.dataset.brands || '').split(',');
      const brandAllowed = !brand || brands.indexOf(brand) !== -1;
      const installAllowed = currentIsRepair || opt.dataset.noInstall !== 'true';
      const allowed = brandAllowed && installAllowed;
      opt.hidden = !allowed;
      opt.disabled = !allowed;
      if (allowed && opt.value === fanTypeSelect.value) currentStillValid = true;
    });

    if (!currentStillValid) fanTypeSelect.value = '';

    const hints = [];
    if (brand === 'Philips') hints.push('Philips is currently available in BLDC ceiling fans only.');
    if (!currentIsRepair) hints.push('Table, Personal, Pedestal, Wall and Exhaust fans are not offered as installation services.');
    fanTypeHint.textContent = hints.join(' ');
  }

  function filterProductType(block){
    const brandSelect = block.querySelector('.brand-select');
    const productTypeSelect = block.querySelector('.productType-select');
    const productTypeHint = block.querySelector('.productType-hint');
    const brand = brandSelect.value;
    let currentStillValid = false;

    Array.from(productTypeSelect.options).forEach(function(opt){
      if (!opt.value) return; // keep placeholder always visible
      const brands = (opt.dataset.brands || '').split(',');
      const brandAllowed = !brand || brands.indexOf(brand) !== -1;
      const installAllowed = currentIsRepair || opt.dataset.noInstall !== 'true';
      const allowed = brandAllowed && installAllowed;
      opt.hidden = !allowed;
      opt.disabled = !allowed;
      if (allowed && opt.value === productTypeSelect.value) currentStillValid = true;
    });

    if (!currentStillValid) productTypeSelect.value = '';

    const hints = [];
    if (!currentIsRepair) hints.push('Installation is currently offered for FANs only.');
    productTypeHint.textContent = hints.join(' ');
  }

  function applyProductType(block){
    const brandSelect = block.querySelector('.brand-select');
    const productTypeSelect = block.querySelector('.productType-select');
    const fanTypeWrap = block.querySelector('.fanType-wrap');
    const fanTypeSelect = block.querySelector('.fanType-select');
    const isFans = productTypeSelect.value === 'Fans';
    const ready = !!brandSelect.value && !!productTypeSelect.value;
    fanTypeWrap.classList.toggle('section-hidden', !isFans);
    fanTypeSelect.required = isFans;
    fanTypeSelect.disabled = !(isFans && ready);
    if (!isFans) fanTypeSelect.value = '';
  }

  function wireBlock(block){
    const brandSelect = block.querySelector('.brand-select');
    const productTypeSelect = block.querySelector('.productType-select');
    const fanTypeSelect = block.querySelector('.fanType-select');
    const modelInput = block.querySelector('.model-input');
    const modelItemCode = block.querySelector('.model-itemcode');
    const modelManualInput = block.querySelector('.model-manual-input');
    const modelManualBack = block.querySelector('.model-manual-back');
    const modelBrowseBtn = block.querySelector('.model-browse-btn');
    const modelSuggestions = block.querySelector('.model-suggestions');
    const modelScopeHint = block.querySelector('.model-scope-hint');

    function updateModelScopeHint(){
      if (catalogLoadState === 'loading'){
        modelScopeHint.textContent = 'Loading product list…';
        return;
      }
      if (catalogLoadState === 'error'){
        modelScopeHint.textContent = 'Could not load products. You can enter the model manually.';
        return;
      }
      const brand = brandSelect.value;
      const productType = productTypeSelect.value;
      if (!brand || !productType){
        modelScopeHint.textContent = '';
        return;
      }
      const parts = [brand, productType === 'Fans' ? 'FANs' : 'Lighting'];
      if (productType === 'Fans' && fanTypeSelect.value){
        const selectedOption = fanTypeSelect.options[fanTypeSelect.selectedIndex];
        if (selectedOption) parts.push(selectedOption.textContent);
      }
      modelScopeHint.textContent = 'Showing ' + parts.join(' — ') + ' products';
    }

    function closeSuggestions(){
      modelSuggestions.classList.add('section-hidden');
      modelSuggestions.innerHTML = '';
    }

    function clearModelSelection(){
      modelInput.value = '';
      modelItemCode.value = '';
      modelManualInput.value = '';
      closeSuggestions();
    }

    function switchToManualEntry(){
      closeSuggestions();
      modelItemCode.value = '';
      const wasRequired = modelInput.required;
      modelInput.classList.add('section-hidden');
      modelInput.disabled = true;
      modelInput.required = false;
      modelManualInput.classList.remove('section-hidden');
      modelManualBack.classList.remove('section-hidden');
      modelManualInput.disabled = false;
      modelManualInput.required = wasRequired;
      modelManualInput.value = '';
      modelManualInput.focus();
    }

    function switchToSearchMode(readyForProduct){
      modelManualInput.classList.add('section-hidden');
      modelManualBack.classList.add('section-hidden');
      const wasRequired = modelManualInput.required;
      modelManualInput.disabled = true;
      modelManualInput.required = false;
      modelInput.classList.remove('section-hidden');
      modelInput.disabled = !readyForProduct;
      modelInput.required = wasRequired;
      modelInput.value = '';
      if (readyForProduct) modelInput.focus();
    }

    // Product Details fields cascade: Model name (search or browse) is only
    // usable once both Brand and Product Type are selected — and the catalog
    // Excel has finished loading (otherwise the list looks empty).
    function updateModelAvailability(){
      const fieldsReady = !!brandSelect.value && !!productTypeSelect.value;
      const catalogReady = catalogLoadState === 'ready' || catalogLoadState === 'error';
      const readyForProduct = fieldsReady && catalogReady;
      const inManualMode = !modelManualInput.classList.contains('section-hidden');

      if (inManualMode && !fieldsReady){
        switchToSearchMode(false);
      } else if (!inManualMode){
        modelInput.disabled = !readyForProduct;
      }
      modelBrowseBtn.disabled = !readyForProduct || catalogLoadState === 'loading';
      if (catalogLoadState === 'loading'){
        modelInput.placeholder = 'Loading products…';
      } else if (readyForProduct){
        modelInput.placeholder = 'Start typing a model name or item code';
      } else {
        modelInput.placeholder = 'Select brand and product type first';
      }

      if (!fieldsReady) clearModelSelection();
    }

    block._refreshCatalogUI = function(){
      updateModelAvailability();
      updateModelScopeHint();
      if (catalogLoadState === 'ready' && modelInput.value.trim().length >= 2){
        runModelSearch();
      }
    };

    function currentCatalogPool(){
      const selectedProductType = productTypeSelect.value;
      let pool = selectedProductType
        ? PRODUCT_CATALOG.filter(function(entry){ return entry[2] === selectedProductType; })
        : PRODUCT_CATALOG;

      // Restrict to the selected Brand (entry[3] — real data, not a guess).
      if (brandSelect.value){
        pool = pool.filter(function(entry){ return entry[3] === brandSelect.value; });
      }

      // If the customer has already picked a Fan type, only show model matches
      // belonging to that fan type (entry[4] — real data, e.g. Exhaust Fan
      // selected -> only exhaust fans).
      if (selectedProductType === 'Fans' && fanTypeSelect.value){
        pool = pool.filter(function(entry){ return entry[4] === fanTypeSelect.value; });
      }
      return pool;
    }

    function renderSuggestions(entries){
      modelSuggestions.innerHTML = '';
      entries.forEach(function(entry){
        const item = document.createElement('div');
        item.className = 'model-suggestion';
        item.innerHTML = entry[1] + '<br><span class="item-code">Item code: ' + entry[0] + '</span>';
        item.addEventListener('mousedown', function(e){
          e.preventDefault(); // keep focus so blur doesn't close before click registers
          modelInput.value = entry[1];
          modelItemCode.value = entry[0];

          // Sync Fan type automatically if the customer picked a model without
          // choosing a Fan type first (or picked one that doesn't match the model).
          if (productTypeSelect.value === 'Fans' && entry[4]){
            const targetOption = fanTypeSelect.querySelector('option[value="' + entry[4] + '"]');
            if (targetOption && !targetOption.hidden && !targetOption.disabled){
              fanTypeSelect.value = entry[4];
            }
          }

          closeSuggestions();
        });
        modelSuggestions.appendChild(item);
      });

      // Always offer a way out for products that aren't in the catalog
      const otherItem = document.createElement('div');
      otherItem.className = 'model-suggestion';
      otherItem.style.fontStyle = 'italic';
      otherItem.style.color = 'var(--accent-dark)';
      otherItem.textContent = "Can't find your product? Enter it manually";
      otherItem.addEventListener('mousedown', function(e){
        e.preventDefault();
        switchToManualEntry();
      });
      modelSuggestions.appendChild(otherItem);

      modelSuggestions.classList.remove('section-hidden');
    }

    function runModelSearch(){
      modelItemCode.value = '';
      const query = modelInput.value.trim().toLowerCase();
      if (!query){
        closeSuggestions();
        return;
      }
      if (query.length < 2){
        closeSuggestions();
        return;
      }
      const pool = currentCatalogPool();
      const matches = pool
        .filter(function(entry){
          return entry[1].toLowerCase().indexOf(query) !== -1 || entry[0].indexOf(query) !== -1;
        })
        .sort(function(a, b){
          function rank(entry){
            if (entry[0].indexOf(query) === 0) return 0; // item code starts with query
            if (entry[1].toLowerCase().indexOf(query) === 0) return 1; // model name starts with query
            return 2; // matches somewhere in the middle
          }
          return rank(a) - rank(b);
        })
        .slice(0, 8);
      renderSuggestions(matches);
    }

    // Browse button: shows a scrollable list of everything currently allowed
    // (by Product Type + Fan type), without requiring the customer to type.
    modelBrowseBtn.addEventListener('click', function(){
      if (modelBrowseBtn.disabled) return;
      modelItemCode.value = '';
      modelInput.value = '';
      renderSuggestions(currentCatalogPool().slice(0, 30));
      modelInput.focus();
    });

    // If the currently-selected model no longer matches the Fan type (or is no
    // longer valid because Brand/Product Type changed), clear it so the fields
    // never show a Model name that's out of sync with the filters above it.
    function reconcileModelWithFanType(){
      if (!modelItemCode.value) return; // nothing picked from the catalog to check
      if (productTypeSelect.value !== 'Fans' || !fanTypeSelect.value) return;
      const entry = CATALOG_BY_ITEMCODE[modelItemCode.value];
      if (!entry || entry[4] !== fanTypeSelect.value){
        clearModelSelection();
      }
    }

    brandSelect.addEventListener('change', function(){
      filterFanTypesByBrand(block);
      filterProductType(block);
      applyProductType(block);
      updateModelAvailability();
      clearModelSelection();
      updateModelScopeHint();
    });
    filterFanTypesByBrand(block);

    const purchaseDateInput = block.querySelector('.purchase-date-input');
    purchaseDateInput.max = TODAY_STR;
    purchaseDateInput.addEventListener('change', function(){
      if (purchaseDateInput.value && purchaseDateInput.value > TODAY_STR){
        purchaseDateInput.value = '';
      }
    });

    productTypeSelect.addEventListener('change', function(){
      filterProductType(block);
      applyProductType(block);
      updateModelAvailability();
      updateModelScopeHint();
    });
    filterProductType(block);
    applyProductType(block);
    updateModelAvailability();
    updateModelScopeHint();

    modelManualBack.addEventListener('click', function(){
      switchToSearchMode(!!brandSelect.value && !!productTypeSelect.value);
    });

    modelInput.addEventListener('input', function(){
      // Only erasing the Model field itself should clear Fan type — Fan type's
      // own change handler also calls runModelSearch() to refresh results, and
      // that must NOT wipe out the Fan type the customer just picked.
      if (!modelInput.value.trim()){
        fanTypeSelect.value = '';
      }
      runModelSearch();
    });

    // Keep results (and the selected model itself) in sync whenever Fan type
    // changes — re-run any in-progress search, and drop a selected model that
    // no longer matches the newly-chosen fan type.
    fanTypeSelect.addEventListener('change', function(){
      reconcileModelWithFanType();
      runModelSearch();
      updateModelScopeHint();
    });
    productTypeSelect.addEventListener('change', runModelSearch);

    modelInput.addEventListener('blur', function(){
      // slight delay so a suggestion click (mousedown) registers first
      setTimeout(closeSuggestions, 100);
    });

    const warrantyRadios = block.querySelectorAll('.warranty-radio');
    const warrantyDisclaimer = block.querySelector('.warranty-disclaimer');
    warrantyRadios.forEach(function(radio){
      radio.addEventListener('change', function(){
        const showDisclaimer = radio.checked && (radio.value === 'No' || radio.value === 'NotSure');
        warrantyDisclaimer.classList.toggle('section-hidden', !showDisclaimer);
      });
    });

    const removeBtn = block.querySelector('.remove-product-btn');
    if (removeBtn){
      removeBtn.addEventListener('click', function(){
        block.remove();
        renumberBlocks();
      });
    }
  }

  function renumberBlocks(){
    const blocks = Array.from(productBlocksContainer.querySelectorAll('.product-block'));
    blocks.forEach(function(block, i){
      let header = block.querySelector('.product-block-header');
      if (blocks.length > 1){
        if (!header){
          header = document.createElement('div');
          header.className = 'product-block-header';
          const title = document.createElement('div');
          title.className = 'product-block-title';
          header.appendChild(title);
          const removeBtn = document.createElement('button');
          removeBtn.type = 'button';
          removeBtn.className = 'remove-product-btn';
          removeBtn.textContent = 'Remove';
          removeBtn.addEventListener('click', function(){
            block.remove();
            renumberBlocks();
          });
          header.appendChild(removeBtn);
          block.insertBefore(header, block.firstChild);
        }
        header.querySelector('.product-block-title').textContent = 'Product ' + (i + 1);
        header.style.display = '';
      } else if (header){
        header.style.display = 'none';
      }
    });
  }

  function addProductBlock(){
    const firstBlock = productBlocksContainer.querySelector('.product-block');
    const newBlock = firstBlock.cloneNode(true);
    newBlock.dataset.index = blockCounter;

    // Reset all field values in the clone
    newBlock.querySelectorAll('input[type="text"], input[type="date"], input[type="hidden"]').forEach(function(el){ el.value = ''; });
    newBlock.querySelectorAll('select').forEach(function(el){ el.value = ''; });
    const qtyInput = newBlock.querySelector('.qty-input');
    if (qtyInput) qtyInput.value = 1;
    const modelSuggestions = newBlock.querySelector('.model-suggestions');
    if (modelSuggestions){ modelSuggestions.classList.add('section-hidden'); modelSuggestions.innerHTML = ''; }

    // Give this block's warranty radios a unique group name
    const warrantyRadios = newBlock.querySelectorAll('input[type="radio"]');
    warrantyRadios.forEach(function(radio, idx){
      radio.name = 'warranty_' + blockCounter;
      radio.checked = (idx === 2); // "Not sure" is the 3rd radio, default checked
    });

    // Remove any leftover header from the clone (renumberBlocks rebuilds it)
    const oldHeader = newBlock.querySelector('.product-block-header');
    if (oldHeader) oldHeader.remove();

    // Clear any error messages carried over from the clone
    newBlock.querySelectorAll('.error-msg').forEach(function(el){ el.style.display = 'none'; });

    // Reset conditional/hidden helper fields in the clone
    const warrantyDisclaimer = newBlock.querySelector('.warranty-disclaimer');
    if (warrantyDisclaimer) warrantyDisclaimer.classList.remove('section-hidden');

    // Always start a new product block in model-search mode, not manual-entry mode
    const cloneModelInput = newBlock.querySelector('.model-input');
    const cloneModelManual = newBlock.querySelector('.model-manual-input');
    const cloneModelManualBack = newBlock.querySelector('.model-manual-back');
    if (cloneModelInput){ cloneModelInput.classList.remove('section-hidden'); cloneModelInput.disabled = false; }
    if (cloneModelManual){ cloneModelManual.classList.add('section-hidden'); cloneModelManual.disabled = true; cloneModelManual.value = ''; }
    if (cloneModelManualBack) cloneModelManualBack.classList.add('section-hidden');

    productBlocksContainer.appendChild(newBlock);
    wireBlock(newBlock);
    applyServiceTypeToBlock(newBlock);
    blockCounter++;
    renumberBlocks();
  }

  addProductBtn.addEventListener('click', addProductBlock);
  wireBlock(productBlocksContainer.querySelector('.product-block'));

  // Built from the Excel file URL (STATE / CITY / PIN_CODE) into:
  // PIN_DATA = { "State": { "City": ["110001", ...] } }
  const PINCODE_INDEX = {};
  const ALL_PINCODES = []; // [pincode, state, city] — used for the pincode search suggestions

  const pincodeInput = document.getElementById('pincode');
  const pincodeSuggestions = document.getElementById('pincodeSuggestions');
  const stateSelect = document.getElementById('state');
  const citySelect = document.getElementById('city');
  const pincodeHint = document.getElementById('pincodeHint');

  function clearPinIndexes(){
    Object.keys(PINCODE_INDEX).forEach(function(key){ delete PINCODE_INDEX[key]; });
    ALL_PINCODES.length = 0;
  }

  function buildPinIndexes(){
    clearPinIndexes();
    Object.keys(PIN_DATA).sort().forEach(function(state){
      Object.keys(PIN_DATA[state]).sort().forEach(function(city){
        PIN_DATA[state][city].forEach(function(pin){
          PINCODE_INDEX[pin] = [state, city];
          ALL_PINCODES.push([pin, state, city]);
        });
      });
    });
  }

  function populateStateOptions(){
    const previous = stateSelect.value;
    stateSelect.innerHTML = '';
    stateSelect.appendChild(new Option('Select state', ''));
    Object.keys(PIN_DATA).sort().forEach(function(state){
      const opt = document.createElement('option');
      opt.value = state;
      opt.textContent = state;
      if (state === previous) opt.selected = true;
      stateSelect.appendChild(opt);
    });
  }

  function applyPinData(data){
    PIN_DATA = data || {};
    buildPinIndexes();
    populateStateOptions();
    if (stateSelect.value) populateCities(stateSelect.value, citySelect.value);
  }

  function rowsToPinData(rows){
    const data = {};
    rows.forEach(function(row){
      const state = String(row.STATE != null ? row.STATE : (row.State || '')).trim();
      const city = String(row.CITY != null ? row.CITY : (row.City || '')).trim();
      let pin = String(row.PIN_CODE != null ? row.PIN_CODE : (row.PINCODE || row.Pincode || '')).trim();
      if (pin.indexOf('.') !== -1) pin = pin.split('.')[0];
      pin = pin.replace(/\D/g, '');
      if (!state || !city || !pin) return;
      if (!data[state]) data[state] = {};
      if (!data[state][city]) data[state][city] = [];
      if (data[state][city].indexOf(pin) === -1) data[state][city].push(pin);
    });
    return data;
  }

  function withTimeout(promise, ms, message){
    return new Promise(function(resolve, reject){
      const timer = setTimeout(function(){ reject(new Error(message)); }, ms);
      promise.then(
        function(value){ clearTimeout(timer); resolve(value); },
        function(err){ clearTimeout(timer); reject(err); }
      );
    });
  }

  function loadScript(src){
    return new Promise(function(resolve, reject){
      const script = document.createElement('script');
      script.src = src;
      script.async = true;
      script.onload = function(){ resolve(); };
      script.onerror = function(){ reject(new Error('Failed to load script: ' + src)); };
      document.head.appendChild(script);
    });
  }

  let sheetJsLoading = null;
  function loadSheetJS(){
    if (window.XLSX) return Promise.resolve();
    if (sheetJsLoading) return sheetJsLoading;

    const sources = [
      'https://cdn.jsdelivr.net/npm/xlsx@0.18.5/dist/xlsx.full.min.js',
      'https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.18.5/xlsx.full.min.js',
      'https://unpkg.com/xlsx@0.18.5/dist/xlsx.full.min.js'
    ];

    sheetJsLoading = (function tryNext(index){
      if (window.XLSX) return Promise.resolve();
      if (index >= sources.length) return Promise.reject(new Error('Failed to load Excel parser'));
      return withTimeout(loadScript(sources[index]), 12000, 'Timed out loading Excel parser')
        .then(function(){
          if (!window.XLSX) throw new Error('Excel parser missing after load');
        })
        .catch(function(){
          return tryNext(index + 1);
        });
    })(0).catch(function(err){
      sheetJsLoading = null;
      throw err;
    });

    return sheetJsLoading;
  }

  function fetchExcelRows(url){
    const controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
    let abortTimer = null;
    const fetchPromise = fetch(url, {
      signal: controller ? controller.signal : undefined,
      cache: 'force-cache'
    }).then(function(res){
      if (!res.ok) throw new Error('Failed to fetch Excel file: ' + url);
      return res.arrayBuffer();
    }).finally(function(){
      if (abortTimer) clearTimeout(abortTimer);
    });

    if (controller){
      abortTimer = setTimeout(function(){
        try { controller.abort(); } catch (e) {}
      }, 40000);
    }

    return loadSheetJS()
      .then(function(){
        return withTimeout(fetchPromise, 40000, 'Timed out fetching Excel file');
      })
      .then(function(buffer){
        let workbook;
        try {
          workbook = window.XLSX.read(buffer, { type: 'array', dense: true });
        } catch (e) {
          workbook = window.XLSX.read(buffer, { type: 'array' });
        }
        const sheet = workbook.Sheets[workbook.SheetNames[0]];
        return window.XLSX.utils.sheet_to_json(sheet, { defval: '', raw: false });
      });
  }

  function pinDataCacheKey(url){
    return 'fanServicePinData:' + url;
  }

  function readCachedPinData(url){
    try {
      const cached = sessionStorage.getItem(pinDataCacheKey(url));
      if (!cached) return null;
      const parsed = JSON.parse(cached);
      return parsed && typeof parsed === 'object' ? parsed : null;
    } catch (e) {
      return null;
    }
  }

  function writeCachedPinData(url, data){
    try {
      sessionStorage.setItem(pinDataCacheKey(url), JSON.stringify(data));
    } catch (e) {}
  }

  function loadPinDataFromExcel(url){
    const cached = readCachedPinData(url);
    if (cached && Object.keys(cached).length){
      applyPinData(cached);
      return Promise.resolve();
    }
    return fetchExcelRows(url).then(function(rows){
      const data = rowsToPinData(rows);
      applyPinData(data);
      writeCachedPinData(url, data);
    });
  }

  function normalizeCatalogBrand(value){
    const raw = String(value || '').trim();
    if (/^ecolink$/i.test(raw)) return 'EcoLink';
    if (/^philips$/i.test(raw)) return 'Philips';
    return raw;
  }

  function normalizeCatalogProductGroup(value){
    const raw = String(value || '').trim();
    if (/lighting/i.test(raw)) return 'Lighting';
    if (/fan/i.test(raw)) return 'Fans';
    return raw;
  }

  function normalizeCatalogProduct(value, productGroup){
    if (productGroup !== 'Fans') return '';
    const raw = String(value || '').trim().toUpperCase();
    if (!raw) return '';
    // Non-BLDC must be checked before BLDC — values like "Non-BLDC Ceiling Fan"
    // contain the substring "BLDC" and would otherwise be misclassified.
    if (/NON[-\s]?BLDC/.test(raw)) return 'NonBLDCCeiling';
    if (raw.indexOf('BLDC') !== -1) return 'BLDCCeiling';
    if (raw.indexOf('EXHAUST') !== -1) return 'Exhaust';
    if (raw.indexOf('TABLE') !== -1) return 'Table';
    if (raw.indexOf('PERSONAL') !== -1) return 'Personal';
    if (raw.indexOf('PEDESTAL') !== -1) return 'Pedestal';
    if (raw.indexOf('WALL') !== -1) return 'Wall';
    // Legacy catalog label for Non-BLDC ceiling fans (e.g. "CEILING FAN")
    if (raw.indexOf('CEILING') !== -1) return 'NonBLDCCeiling';
    return 'Other';
  }

  function rowsToProductCatalog(rows){
    const catalog = [];
    const seen = {};
    rows.forEach(function(row){
      const modelCode = String(row.MODEL_CODE != null ? row.MODEL_CODE : '').trim();
      const modelDescription = String(row.MODEL_DESCRIPTION != null ? row.MODEL_DESCRIPTION : '').trim();
      const productGroup = normalizeCatalogProductGroup(row.PRODUCT_GROUP);
      const brand = normalizeCatalogBrand(row.BRAND);
      const product = normalizeCatalogProduct(row.PRODUCT, productGroup);
      if (!modelCode || !modelDescription) return;
      if (seen[modelCode]) return;
      seen[modelCode] = true;
      catalog.push([modelCode, modelDescription, productGroup, brand, product]);
    });
    return catalog;
  }

  function applyProductCatalog(data){
    PRODUCT_CATALOG = data || [];
    rebuildCatalogIndex();
  }

  function productCatalogCacheKey(url){
    return 'fanServiceProductCatalog:' + url;
  }

  function readCachedProductCatalog(url){
    try {
      const cached = sessionStorage.getItem(productCatalogCacheKey(url));
      if (!cached) return null;
      const parsed = JSON.parse(cached);
      return Array.isArray(parsed) && parsed.length ? parsed : null;
    } catch (e) {
      return null;
    }
  }

  function writeCachedProductCatalog(url, data){
    try {
      sessionStorage.setItem(productCatalogCacheKey(url), JSON.stringify(data));
    } catch (e) {}
  }

  function setCatalogLoadState(state){
    catalogLoadState = state;
    refreshAllCatalogUI();
  }

  function loadProductCatalogFromExcel(url){
    const cached = readCachedProductCatalog(url);
    if (cached){
      applyProductCatalog(cached);
      setCatalogLoadState('ready');
      return Promise.resolve();
    }

    setCatalogLoadState('loading');
    return fetchExcelRows(url).then(function(rows){
      const catalog = rowsToProductCatalog(rows);
      applyProductCatalog(catalog);
      writeCachedProductCatalog(url, catalog);
      setCatalogLoadState('ready');
    }).catch(function(err){
      setCatalogLoadState('error');
      throw err;
    });
  }

  function populateCities(state, selectedCity){
    citySelect.innerHTML = '';
    if (!state || !PIN_DATA[state]){
      citySelect.appendChild(new Option('Select state first', ''));
      return;
    }
    citySelect.appendChild(new Option('Select city', ''));
    Object.keys(PIN_DATA[state]).sort().forEach(function(city){
      const opt = new Option(city, city);
      if (city === selectedCity) opt.selected = true;
      citySelect.appendChild(opt);
    });
  }

  // Current allowed pincode pool, based on whatever State/City is already selected.
  // Logic 02: once a State is chosen, only pincodes (and cities) within that state are ever shown.
  function currentPool(){
    let pool = ALL_PINCODES;
    if (stateSelect.value) pool = pool.filter(function(e){ return e[1] === stateSelect.value; });
    if (citySelect.value) pool = pool.filter(function(e){ return e[2] === citySelect.value; });
    return pool;
  }

  function closePincodeSuggestions(){
    pincodeSuggestions.classList.add('section-hidden');
    pincodeSuggestions.innerHTML = '';
  }

  function renderPincodeSuggestions(entries){
    if (!entries.length){
      closePincodeSuggestions();
      return;
    }
    pincodeSuggestions.innerHTML = '';
    entries.slice(0, 20).forEach(function(entry){
      const item = document.createElement('div');
      item.className = 'model-suggestion';
      item.innerHTML = entry[0] + '<br><span class="item-code">' + entry[2] + ', ' + entry[1] + '</span>';
      item.addEventListener('mousedown', function(e){
        e.preventDefault();
        applyPincodeMatch(entry[0], entry[1], entry[2]);
      });
      pincodeSuggestions.appendChild(item);
    });
    pincodeSuggestions.classList.remove('section-hidden');
  }

  // Logic 01: selecting/confirming a pincode always sets State and City to match it.
  function applyPincodeMatch(pin, state, city){
    pincodeInput.value = pin;
    stateSelect.value = state;
    populateCities(state, city);
    pincodeHint.textContent = 'State and city auto-filled from pincode — please verify.';
    closePincodeSuggestions();
  }

  // Typing/focusing Pincode: always searched within the current pool (i.e. within the
  // already-selected State/City, if any) — a typed pincode outside that state is never
  // allowed to silently override the customer's state selection.
  pincodeInput.addEventListener('input', function(){
    pincodeHint.textContent = '';
    const query = pincodeInput.value.trim();

    if (!query){
      stateSelect.value = '';
      populateCities('', '');
      closePincodeSuggestions();
      return;
    }

    const pool = currentPool();

    if (/^[0-9]{6}$/.test(query)){
      const exact = pool.find(function(e){ return e[0] === query; });
      if (exact){
        applyPincodeMatch(exact[0], exact[1], exact[2]);
        return;
      }
      if (stateSelect.value){
        pincodeHint.textContent = 'This pincode is not in ' + stateSelect.value + (citySelect.value ? ', ' + citySelect.value : '') + '.';
        closePincodeSuggestions();
        return;
      }
      // No state selected yet — fall back to the full dataset (logic 01)
      if (PINCODE_INDEX[query]){
        const match = PINCODE_INDEX[query];
        applyPincodeMatch(query, match[0], match[1]);
        return;
      }
    }

    if (query.length < 2){
      closePincodeSuggestions();
      return;
    }

    renderPincodeSuggestions(pool.filter(function(e){ return e[0].indexOf(query) !== -1; }));
  });

  // Focusing an empty Pincode field with a State already selected: let them browse/pick
  // from that state's pincodes instead of having to type.
  pincodeInput.addEventListener('focus', function(){
    if (pincodeInput.value.trim()) return;
    if (!stateSelect.value) return;
    renderPincodeSuggestions(currentPool());
  });

  pincodeInput.addEventListener('blur', function(){
    setTimeout(closePincodeSuggestions, 100);
  });

  // Selecting State: narrow City options to that state; clear Pincode if it no longer fits
  stateSelect.addEventListener('change', function(){
    populateCities(stateSelect.value, '');
    pincodeHint.textContent = '';
    closePincodeSuggestions();
    const currentPin = pincodeInput.value.trim();
    if (currentPin && PINCODE_INDEX[currentPin] && PINCODE_INDEX[currentPin][0] !== stateSelect.value){
      pincodeInput.value = '';
    }
  });

  // Selecting City: clear Pincode if it no longer matches the state+city combination
  citySelect.addEventListener('change', function(){
    pincodeHint.textContent = '';
    closePincodeSuggestions();
    const currentPin = pincodeInput.value.trim();
    if (currentPin && PINCODE_INDEX[currentPin]){
      const match = PINCODE_INDEX[currentPin];
      if (match[0] !== stateSelect.value || (citySelect.value && match[1] !== citySelect.value)){
        pincodeInput.value = '';
      }
    }
  });

  const config = window.FanServiceFormConfig || {};
  const pinCodeFileUrl = config.pinCodeFileUrl || '';
  const productCatalogFileUrl = config.productCatalogFileUrl || '';

  function setPinFieldsLoading(isLoading, hint){
    if (pincodeHint) pincodeHint.textContent = hint || '';
    if (pincodeInput) pincodeInput.disabled = !!isLoading;
    if (stateSelect) stateSelect.disabled = !!isLoading;
    if (citySelect) citySelect.disabled = !!isLoading;
  }

  if (pinCodeFileUrl && pincodeInput && pincodeHint && stateSelect && citySelect){
    setPinFieldsLoading(true, 'Loading pincode data…');
    loadPinDataFromExcel(pinCodeFileUrl)
      .then(function(){
        setPinFieldsLoading(false, '');
      })
      .catch(function(err){
        console.error(err);
        setPinFieldsLoading(false, 'Could not load pincode data. Please refresh the page.');
      });
  }

  if (productCatalogFileUrl){
    loadProductCatalogFromExcel(productCatalogFileUrl)
      .catch(function(err){
        console.error(err);
        if (catalogLoadState !== 'error') setCatalogLoadState('error');
      });
  } else {
    setCatalogLoadState('ready');
  }

  function applyServiceTypeToBlock(block){
    const modelInput = block.querySelector('.model-input');
    const modelManualInput = block.querySelector('.model-manual-input');
    const modelLabel = block.querySelector('.model-label');
    const purchaseDateInput = block.querySelector('.purchase-date-input');
    const warrantyWrap = block.querySelector('.warranty-wrap');

    modelLabel.firstChild.textContent = currentIsRepair ? 'Model name or item code' : 'Model name or item code (if purchased)';
    if (!modelInput.disabled) modelInput.required = currentIsRepair;
    if (!modelManualInput.disabled) modelManualInput.required = currentIsRepair;
    purchaseDateInput.required = currentIsRepair;
    warrantyWrap.classList.toggle('section-hidden', !currentIsRepair);
  }

  function setServiceType(type){
    currentIsRepair = type === 'Repair';
    repairSection.classList.toggle('section-hidden', !currentIsRepair);

    labelRepair.classList.toggle('active', currentIsRepair);
    labelInstall.classList.toggle('active', !currentIsRepair);

    addressLabel.firstChild.textContent = currentIsRepair ? 'Service address' : 'Installation address';
    submitBtn.textContent = currentIsRepair ? 'Submit repair request' : 'Submit installation request';

    issueCategory.required = currentIsRepair;
    issueDescription.required = currentIsRepair;

    productBlocksContainer.querySelectorAll('.product-block').forEach(function(block){
      applyServiceTypeToBlock(block);
      filterFanTypesByBrand(block);
      filterProductType(block);
      applyProductType(block);
    });
  }

  document.querySelectorAll('input[name="serviceType"]').forEach(function(radio){
    radio.addEventListener('change', function(){ setServiceType(this.value); });
  });
  setServiceType('Repair');

  const consentInput = document.getElementById('consent');
  const consentError = document.getElementById('consentError');
  if (consentInput && consentError){
    consentInput.addEventListener('change', function(){
      if (consentInput.checked) consentError.style.display = 'none';
    });
  }

  function getCleanLabelText(labelEl){
    if (!labelEl) return '';
    const clone = labelEl.cloneNode(true);
    clone.querySelectorAll('.required, .opt, a').forEach(function(el){ el.remove(); });
    return clone.textContent.replace(/\s+/g, ' ').trim();
  }

  function getFieldLabel(field){
    if (field.name === 'serviceType') return 'Service type';
    if (field.classList.contains('model-itemcode')) return 'Item code';
    if (field.id === 'address') return currentIsRepair ? 'Service address' : 'Installation address';
    if (field.id === 'repairAttachment' || field.name === 'attachment') return 'Choose file';

    if (field.id){
      const byFor = form.querySelector('label[for="' + field.id + '"]');
      if (byFor) return getCleanLabelText(byFor);
    }

    const wrap = field.closest('div');
    if (wrap){
      const label = Array.from(wrap.children).find(function(el){
        return el.tagName === 'LABEL' && !el.querySelector('input, select, textarea');
      });
      if (label) return getCleanLabelText(label);
    }

    if (field.type === 'radio'){
      const group = field.closest('.radio-group');
      if (group && group.parentElement){
        const groupLabel = Array.from(group.parentElement.children).find(function(el){
          return el.tagName === 'LABEL' && !el.querySelector('input');
        });
        if (groupLabel) return getCleanLabelText(groupLabel);
      }
    }

    return field.name || field.id || 'Field';
  }

  function getFieldValue(field){
    if (field.type === 'checkbox') return field.checked ? 'Yes' : 'No';
    // File fields are uploaded separately and mapped after a successful upload.
    if (field.type === 'file') return '';
    return (field.value || '').trim();
  }

  function isFieldCollectable(field){
    if (!field || field.disabled) return false;
    if (field.type === 'button' || field.type === 'submit') return false;
    if (field.type === 'file') return false;
    if (field.type === 'radio' && !field.checked) return false;
    if (field.closest('.section-hidden')) return false;
    if (field.type !== 'hidden' && field.offsetParent === null) return false;
    return true;
  }

  function collectProductDetailsString(){
    const blocks = productBlocksContainer.querySelectorAll('.product-block');
    const blockStrings = [];

    blocks.forEach(function(block){
      const pairs = [];
      const seenLabels = {};

      block.querySelectorAll('input, select, textarea').forEach(function(field){
        const isItemCode = field.classList.contains('model-itemcode');
        if (isItemCode){
          if (!field.value) return;
        } else if (!isFieldCollectable(field)){
          return;
        }

        const label = getFieldLabel(field);
        if (!label || seenLabels[label]) return;
        seenLabels[label] = true;
        pairs.push(label + ':' + getFieldValue(field));
      });

      if (pairs.length) blockStrings.push(pairs.join(', '));
    });

    return blockStrings.join(' | ');
  }

  function pad2(n){
    return String(n).padStart(2, '0');
  }

  // Per-submission ID for both Repair and Installation Hulk forms.
  // Date stamp is always IST (Asia/Kolkata, UTC+5:30, no DST) so the
  // email subject matches India time regardless of the customer's timezone.
  // Format: SR-R-YYYYMMDDHHMMSS-XXXXXXXX or SR-I-...
  const IST_OFFSET_MS = (5 * 60 + 30) * 60 * 1000;

  function generateUniqueId(){
    const ist = new Date(Date.now() + IST_OFFSET_MS);
    const stamp =
      ist.getUTCFullYear() +
      pad2(ist.getUTCMonth() + 1) +
      pad2(ist.getUTCDate()) +
      pad2(ist.getUTCHours()) +
      pad2(ist.getUTCMinutes()) +
      pad2(ist.getUTCSeconds());
    const prefix = currentIsRepair ? 'SR-R' : 'SR-I';
    let rand = '';
    if (window.crypto && typeof window.crypto.getRandomValues === 'function'){
      const bytes = new Uint8Array(4);
      window.crypto.getRandomValues(bytes);
      rand = Array.prototype.map.call(bytes, function(b){
        return b.toString(16).padStart(2, '0');
      }).join('').toUpperCase();
    } else {
      rand = Math.random().toString(16).slice(2, 10).toUpperCase();
    }
    return prefix + '-' + stamp + '-' + rand;
  }

  function getUniqueIdFieldLabel(){
    const label = (config.uniqueIdFieldLabel || 'Unique ID').trim();
    return label || 'Unique ID';
  }

  function buildFormPayload(){
    const payload = {};

    form.querySelectorAll('input, select, textarea').forEach(function(field){
      if (productBlocksContainer.contains(field)) return;
      if (!isFieldCollectable(field)) return;
      // Consent is local-only validation; HulkApps form fields do not include it.
      if (field.name === 'consent') return;

      const label = getFieldLabel(field);
      if (!label) return;
      payload[label] = getFieldValue(field);
    });

    payload['Product details'] = collectProductDetailsString();
    // Hidden tracking value — must match a Hulk field label on both forms.
    payload[getUniqueIdFieldLabel()] = generateUniqueId();
    return payload;
  }

  function getActiveFormId(){
    // Prefer the active tab class; fall back to currentIsRepair.
    if (labelInstall && labelInstall.classList.contains('active')){
      return config.installFormId || 'xPA9Bx-KFSSTN1lLjQ2JiA';
    }
    if (labelRepair && labelRepair.classList.contains('active')){
      return config.formId || 'hne2Yd8IgTiKKxb7MopQkQ';
    }
    return currentIsRepair
      ? (config.formId || 'hne2Yd8IgTiKKxb7MopQkQ')
      : (config.installFormId || 'xPA9Bx-KFSSTN1lLjQ2JiA');
  }

  const MAX_ATTACHMENT_BYTES = 5 * 1024 * 1024;
  const repairAttachmentInput = document.getElementById('repairAttachment');
  const repairAttachmentError = document.getElementById('repairAttachmentError');

  function showAttachmentError(message){
    if (!repairAttachmentError) return;
    repairAttachmentError.textContent = message || 'Please choose a valid file (image or PDF, max 5MB).';
    repairAttachmentError.style.display = 'block';
  }

  function clearAttachmentError(){
    if (!repairAttachmentError) return;
    repairAttachmentError.style.display = 'none';
  }

  function getSelectedAttachmentFile(){
    if (!repairAttachmentInput || repairAttachmentInput.disabled) return null;
    if (repairAttachmentInput.closest('.section-hidden')) return null;
    if (!repairAttachmentInput.files || !repairAttachmentInput.files[0]) return null;
    return repairAttachmentInput.files[0];
  }

  function validateAttachmentFile(file){
    if (!file) return null;
    if (file.size > MAX_ATTACHMENT_BYTES){
      return 'File is too large. Please upload an image or PDF up to 5MB.';
    }
    const type = (file.type || '').toLowerCase();
    const name = (file.name || '').toLowerCase();
    const isImage = type.indexOf('image/') === 0;
    const isPdf = type === 'application/pdf' || name.slice(-4) === '.pdf';
    if (!isImage && !isPdf){
      return 'Please choose an image or PDF file.';
    }
    return null;
  }

  if (repairAttachmentInput){
    repairAttachmentInput.addEventListener('change', function(){
      clearAttachmentError();
      const file = getSelectedAttachmentFile();
      if (!file) return;
      const validationError = validateAttachmentFile(file);
      if (validationError){
        showAttachmentError(validationError);
        repairAttachmentInput.value = '';
      }
    });
  }

  function uploadAttachmentToHulkApps(file){
    const baseUrl = (config.formApiBaseUrl || 'https://formbuilder.hulkapps.com').replace(/\/$/, '');
    // File field belongs to the Repair form — always upload against that form ID.
    const formId = config.formId || 'hne2Yd8IgTiKKxb7MopQkQ';
    const token = config.formAccessToken || '';

    if (!formId || !token){
      return Promise.reject(new Error('File upload is not configured'));
    }

    const body = new FormData();
    body.append('file_data', file, file.name);

    return fetch(baseUrl + '/forms/file_upload/' + encodeURIComponent(formId), {
      method: 'POST',
      headers: {
        'X-Form-Access-Token': token
      },
      body: body
    }).then(function(res){
      return res.json().catch(function(){ return {}; }).then(function(data){
        if (!res.ok){
          throw new Error((data && (data.message || data.error)) || 'File upload failed');
        }
        if (data && data.error){
          throw new Error(typeof data.error === 'string' ? data.error : 'File upload failed');
        }
        const uploaded = data && data.response;
        const fileUrl = uploaded && uploaded.url;
        if (!fileUrl){
          throw new Error((data && data.message) || 'File upload failed');
        }
        return {
          id: uploaded.id,
          url: fileUrl,
          type: uploaded.type || 'file'
        };
      });
    });
  }

  function buildChooseFileFieldValue(uploaded){
    const fileEntry = {
      url: uploaded.url,
      type: 'file'
    };
    if (uploaded.id != null && uploaded.id !== ''){
      fileEntry.id = uploaded.id;
    }
    // Match Hulk Forms public API sample payload shape for file fields.
    return {
      files: [fileEntry],
      type: 'file',
      upload_type: 'multiple'
    };
  }

  function submitFormToHulkApps(payload){
    const baseUrl = (config.formApiBaseUrl || 'https://formbuilder.hulkapps.com').replace(/\/$/, '');
    const formId = getActiveFormId();
    const token = config.formAccessToken || '';
    if (!formId || !token){
      return Promise.reject(new Error('Form Builder API is not configured'));
    }

    return fetch(baseUrl + '/forms/create_response/' + encodeURIComponent(formId), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Form-Access-Token': token
      },
      body: JSON.stringify({ formResponse: payload })
    }).then(function(res){
      return res.json().catch(function(){ return {}; }).then(function(data){
        if (!res.ok){
          throw new Error((data && (data.message || data.error)) || 'Request failed');
        }
        if (data && (data.message === 'Access denied' || data.error)){
          throw new Error(data.message || data.error);
        }
        // HulkApps returns { validate: false } when field validation fails and nothing is saved.
        if (data && data.validate === false){
          throw new Error('Form validation failed');
        }
        return data;
      });
    });
  }

  form.addEventListener('submit', function(e){
    e.preventDefault();
    successMsg.style.display = 'none';
    errorMsg.style.display = 'none';
    clearAttachmentError();

    let valid = true;
    form.querySelectorAll('.error-msg').forEach(el => el.style.display = 'none');

    form.querySelectorAll('[required]').forEach(function(field){
      if (field.offsetParent === null) return; // skip hidden-section fields
      const container = field.closest('.row') || field.parentElement;
      if (field.type === 'checkbox' && !field.checked){
        valid = false;
        if (field.id === 'consent'){
          const consentErr = document.getElementById('consentError');
          if (consentErr) consentErr.style.display = 'block';
        } else {
          const err = container.querySelector('.error-msg');
          if (err) err.style.display = 'block';
        }
      } else if (field.type !== 'checkbox' && !field.value.trim()){
        valid = false;
        const err = container.querySelector('.error-msg');
        if (err) err.style.display = 'block';
      } else if (field.pattern && field.value && !(new RegExp('^'+field.pattern+'$')).test(field.value)){
        valid = false;
        const err = container.querySelector('.error-msg');
        if (err) err.style.display = 'block';
      } else if (field.classList.contains('purchase-date-input') && field.value > TODAY_STR){
        valid = false;
        field.value = '';
        const err = container.querySelector('.error-msg');
        if (err) err.style.display = 'block';
      }
    });

    const attachmentFile = getSelectedAttachmentFile();
    if (attachmentFile){
      const attachmentValidationError = validateAttachmentFile(attachmentFile);
      if (attachmentValidationError){
        valid = false;
        showAttachmentError(attachmentValidationError);
      }
    }

    if (!valid){
      return;
    }

    const payload = buildFormPayload();
    const previousBtnText = submitBtn.textContent;
    const defaultErrorText = errorMsg
      ? (errorMsg.getAttribute('data-default-text') || errorMsg.textContent)
      : '';
    if (errorMsg && !errorMsg.getAttribute('data-default-text')){
      errorMsg.setAttribute('data-default-text', defaultErrorText);
    }

    submitBtn.disabled = true;
    submitBtn.textContent = attachmentFile ? 'Uploading file…' : 'Submitting…';

    let uploadFailed = false;
    const uploadPromise = attachmentFile
      ? uploadAttachmentToHulkApps(attachmentFile).then(function(uploaded){
          payload['Choose file'] = buildChooseFileFieldValue(uploaded);
        }).catch(function(err){
          uploadFailed = true;
          throw err;
        })
      : Promise.resolve();

    uploadPromise
      .then(function(){
        submitBtn.textContent = 'Submitting…';
        return submitFormToHulkApps(payload);
      })
      .then(function(){
        successMsg.style.display = 'block';
        form.reset();
        setServiceType('Repair');
        productBlocksContainer.querySelectorAll('.product-block').forEach(function(block){
          filterFanTypesByBrand(block);
          filterProductType(block);
          applyProductType(block);
        });
      })
      .catch(function(err){
        console.error(err);
        if (uploadFailed){
          showAttachmentError('File upload failed. Please try again or remove the file before submitting.');
          if (errorMsg){
            errorMsg.textContent = 'File upload failed. Your request was not submitted. Please try again.';
            errorMsg.style.display = 'block';
          }
        } else if (errorMsg){
          errorMsg.textContent = defaultErrorText;
          errorMsg.style.display = 'block';
        }
      })
      .finally(function(){
        submitBtn.disabled = false;
        submitBtn.textContent = previousBtnText;
      });
  });
})();
